import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { withCookies, Cookies } from 'react-cookie'

class ReportItemSimple extends Component {
    render() {
        const appName = this.props.cookies.get('app_name')
        let EmptyImg = require('../../../Res/img/hausplanner_logo_gold3.png')
        if (appName && appName !== '') {
            EmptyImg = require(`../../../Res/3rd/${appName}/img/empty_img.png`)
        }

        // 날짜 변환
        const newDate = new Date(this.props.item.workDate)
        const newYear = newDate.getFullYear()
        const week = new Array('일', '월', '화', '수', '목', '금', '토')
        const newDayName = week[newDate.getDay()]

        let newMonth = newDate.getMonth() + 1
        if (newMonth < 10) {
            newMonth = '0' + newMonth
        }
        let newDay = newDate.getDate()
        if (newDay < 10) {
            newDay = '0' + newDay
        }
        let newHours = newDate.getHours()
        if (newHours < 10) {
            newHours = '0' + newHours
        }
        let newMinutes = newDate.getMinutes()
        if (newMinutes < 10) {
            newMinutes = '0' + newMinutes
        }

        // 날씨
        let weatherText = ''
        let weatherIcon = ''

        if (this.props.item.weather === 'sun') {
            weatherText = '맑음'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22">\
          <g fill="none" fillRule="evenodd" stroke="#FEBD01">\
            <path strokeWidth="1.2" d="M10.765 6.105c-2.666 0-4.839 2.196-4.839 4.896 0 2.7 2.173 4.896 4.839 4.896 2.666 0 4.839-2.195 4.839-4.896 0-2.7-2.173-4.896-4.84-4.896z"/>\
            <path strokeLinecap="round" strokeWidth=".7" d="M10.517.885c0-.124.105-.225.225-.225.124 0 .225.096.225.225v2.423a.227.227 0 0 1-.225.226.222.222 0 0 1-.225-.226V.885zM16.48 2.69a.227.227 0 0 1 .314-.05c.1.072.126.209.05.314l-1.424 1.96a.227.227 0 0 1-.315.05.222.222 0 0 1-.049-.314l1.424-1.96zm3.77 4.984a.227.227 0 0 1 .285.144.222.222 0 0 1-.145.284l-2.304.748a.227.227 0 0 1-.284-.144.222.222 0 0 1 .145-.283l2.304-.749zm.14 6.263a.227.227 0 0 1 .145.283.222.222 0 0 1-.284.144l-2.304-.749a.227.227 0 0 1-.145-.283.222.222 0 0 1 .284-.144l2.304.749zm-3.546 5.148c.073.1.048.243-.05.314a.222.222 0 0 1-.314-.05l-1.424-1.96a.227.227 0 0 1 .05-.315.222.222 0 0 1 .314.05l1.424 1.96zm-5.877 2.067a.227.227 0 0 1-.225.226.222.222 0 0 1-.225-.226v-2.423c0-.124.105-.225.225-.225.124 0 .225.095.225.225v2.423zm-5.963-1.803a.227.227 0 0 1-.314.05.222.222 0 0 1-.05-.314l1.425-1.96a.227.227 0 0 1 .314-.05c.1.072.126.209.05.314l-1.425 1.96zm-3.77-4.985a.227.227 0 0 1-.284-.144.222.222 0 0 1 .145-.283l2.304-.749a.227.227 0 0 1 .284.144.222.222 0 0 1-.145.283l-2.305.75zm-.14-6.262a.227.227 0 0 1-.144-.284.222.222 0 0 1 .283-.144l2.305.749a.227.227 0 0 1 .145.283.222.222 0 0 1-.284.144l-2.304-.748zm3.547-5.148a.227.227 0 0 1 .049-.315.222.222 0 0 1 .314.05l1.424 1.96c.074.101.049.244-.049.315a.222.222 0 0 1-.314-.05L4.64 2.953z"/>\
          </g>\
        </svg>'
        } else if (this.props.item.weather === 'cloud') {
            weatherText = '구름낌'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18">\
          <g fill="none" fillRule="evenodd">\
            <path stroke="#B7BEC8" strokeWidth="1.2" d="M20.574 9.536c-.27 0-.54.03-.803.087-.842-1.98-2.808-3.3-4.935-3.3-2.654 0-4.86 1.897-5.3 4.532h-.019c-1.735 0-3.147 1.433-3.147 3.194s1.412 3.194 3.147 3.194h11.057c2.093 0 3.796-1.729 3.796-3.854 0-2.124-1.703-3.853-3.796-3.853z"/>\
            <g stroke="#FEBD01" strokeLinecap="round">\
              <path d="M11.492 5.45a4 4 0 0 0-5.727 5.533"/>\
              <path strokeWidth=".8" d="M9.707.973a.165.165 0 0 1 .19-.132c.09.016.15.097.133.19l-.304 1.723a.165.165 0 0 1-.19.132.161.161 0 0 1-.133-.189L9.707.973zm4.057 2.038a.165.165 0 0 1 .23.005.161.161 0 0 1-.002.23l-1.26 1.217a.165.165 0 0 1-.231-.005.161.161 0 0 1 .003-.231l1.26-1.216zM3.43 13.415a.165.165 0 0 1-.231-.005.161.161 0 0 1 .003-.23l1.26-1.217a.165.165 0 0 1 .23.005.161.161 0 0 1-.003.231l-1.26 1.216zM1.348 9.391a.165.165 0 0 1-.184-.14.161.161 0 0 1 .138-.185l1.734-.244a.165.165 0 0 1 .184.14.161.161 0 0 1-.138.185l-1.734.244zm.686-4.475a.165.165 0 0 1-.067-.22.161.161 0 0 1 .22-.07l1.547.823c.08.042.108.143.067.221a.161.161 0 0 1-.221.068l-1.546-.822zm3.193-3.215a.165.165 0 0 1 .076-.218.161.161 0 0 1 .219.074l.767 1.574c.04.08.003.18-.076.218a.161.161 0 0 1-.219-.074L5.227 1.7z"/>\
            </g>\
          </g>\
        </svg>'
        } else if (this.props.item.weather === 'gray') {
            weatherText = '흐림'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17">\
          <g fill="none" fillRule="evenodd" stroke="#B7BEC8" strokeWidth="1.2">\
            <path d="M19.574 8.536c-.27 0-.54.03-.803.087-.842-1.98-2.808-3.3-4.935-3.3-2.654 0-4.86 1.897-5.3 4.532h-.019c-1.735 0-3.147 1.433-3.147 3.194s1.412 3.194 3.147 3.194h11.057c2.093 0 3.796-1.729 3.796-3.854 0-2.124-1.703-3.853-3.796-3.853zM11.58 3.539C10.888 1.914 9.275.83 7.53.83c-2.18 0-3.99 1.557-4.351 3.72C1.739 4.55.58 5.726.58 7.172c0 1.445 1.159 2.621 2.583 2.621h1.24"/>\
          </g>\
        </svg>'
        } else if (this.props.item.weather === 'rain') {
            weatherText = '비'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">\
          <g fill="none" fillRule="evenodd">\
            <path stroke="#B7BEC8" strokeWidth="1.2" d="M18.39 4.798c-.329 0-.657.036-.979.107C16.384 2.49 13.987.88 11.393.88 8.156.88 5.465 3.194 4.93 6.407h-.023c-2.116 0-3.837 1.747-3.837 3.895 0 2.147 1.721 3.895 3.837 3.895H18.39c2.553 0 4.63-2.109 4.63-4.7 0-2.59-2.077-4.699-4.63-4.699z"/>\
            <g stroke="#5B8BF7" strokeLinecap="round">\
              <path d="M5.833 17.125L7 19.145M10.5 17.125l1.167 2.02M15.167 17.125l1.166 2.02M19.833 17.125L21 19.145"/>\
            </g>\
          </g>\
        </svg>'
        } else if (this.props.item.weather === 'snow') {
            weatherText = '눈'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22">\
          <g fill="none" fillRule="evenodd" stroke="#5B8BF7" stroke:inecap="round" strokeWidth="1.1">\
            <path d="M9.976 1.154v19.692M12.988 2.419L10.01 5.397 6.964 2.35M12.988 19.581l-2.978-2.978-3.046 3.046"/>\
            <g>\
              <path d="M1.609 5.772l16.595 9.581M4.156 3.908L5.185 7.75 1.136 8.835M18.545 12.215l-3.842 1.03 1.085 4.049"/>\
            </g>\
            <g>\
              <path d="M18.273 5.766L1.678 15.347M18.614 8.904l-3.842-1.03 1.085-4.048M4.225 17.212l1.03-3.842-4.05-1.085"/>\
            </g>\
          </g>\
        </svg>'
        }

        return (
            <li>
                <Link to={`/report/${this.props.item._id}`}>
                    <div className="date_wrap">
                        <div className="date">
                            {newYear}.{newMonth}.{newDay} ({newDayName})
                        </div>
                    </div>
                    <div className="thumbnail_wrap">
                        {this.props.item.dayoff && (
                            <div className="day_off_wrap">
                                <div className="day_off">휴무</div>
                            </div>
                        )}
                        <div className="thumbnail">
                            {this.props.item.thumbnailUrl ? (
                                <LazyLoadImage src={this.props.item.thumbnailUrl} />
                            ) : (
                                <img src={EmptyImg} />
                            )}
                        </div>
                    </div>
                </Link>
            </li>
        )
    }
}

export default withCookies(ReportItemSimple)



// WEBPACK FOOTER //
// ./Src/Components/Report/ReportItemSimple.js